module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible bulk-wrapper",
    attrs: {
      "data-animation": "pop"
    }
  }, [(_vm.displayQuestion) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Transfer all notes to another account")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [(_vm.loading) ? _c('spinner', {
    attrs: {
      "text": _vm.loadingText,
      "inline": ""
    }
  }) : (_vm.loadFailed) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_vm._v("We could not load this account's notes")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadError))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadPreview
    }
  }, [_vm._v("\n                  Try again\n                ")])])])])]) : (_vm.result) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.result.failed ? 'alert-warning' : 'alert-success',
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.result.failed) ? _c('h4', [_vm._v(_vm._s(_vm.result.title))]) : _c('h4', [_vm._v(_vm._s(_vm.result.title) + " — with failures")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.result.message))])]), _vm._v(" "), (_vm.result.failed) ? _c('div', {
    staticClass: "failures-block"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n              These notes were not processed and must be handled individually\n              from each note's Transfer page:\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "failure-list"
  }, _vm._l((_vm.result.failures), function(failure) {
    return _c('li', {
      key: failure.noteId
    }, [_vm._v("\n                Note #" + _vm._s(failure.noteId) + "\n                "), (failure.failedPhase) ? _c('span', [_vm._v("\n                  (" + _vm._s(_vm.failedPhaseText(failure.failedPhase)) + ")\n                ")]) : _vm._e(), _vm._v("\n                — " + _vm._s(failure.errorMessage) + "\n              ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Done\n                ")])])])])]) : (_vm.isApproval) ? _c('div', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              A bulk transfer of "), _c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))]), _vm._v(" notes\n              to account "), _c('strong', [_vm._v(_vm._s(_vm.destinationLabel))]), _vm._v(" is awaiting\n              approval on this account.\n            ")])]), _vm._v(" "), (_vm.openBatch.electionsToReset) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.openBatch.electionsToReset) + " upcoming transaction(s) are\n              scheduled on these notes. Approving resets them, and anything\n              the investor already chose must be chosen again on the\n              destination account.\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.openBatch.totalPrincipal || 0)) + "\n              ")])]), _vm._v(" "), (_vm.openBatch.electionsToReset) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Upcoming transactions")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.openBatch.electionsToReset) + "\n              ")])]) : _vm._e()]), _vm._v(" "), (_vm.requestNotes.length) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.requestNotes.length) + " notes\n              being transferred\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes && _vm.requestNotes.length) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Upcoming")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.requestNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.principalAmount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(note.electionsToReset) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('em', {
      staticClass: "fa fa-warning pr-sm"
    }), _vm._v(_vm._s(note.electionsToReset) + "\n                    ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferApprovalComment"
    }
  }, [_vm._v("\n              Please append your comment below *\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approvalComment),
      expression: "approvalComment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferApprovalComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.approvalComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.approvalComment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.canApprove) ? _c('p', {
    staticClass: "text-danger"
  }, [_c('em', [_vm._v("You must enter or append a comment.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-discard",
    attrs: {
      "type": "button",
      "disabled": !_vm.canApprove
    },
    on: {
      "click": _vm.confirmCancelBatch
    }
  }, [_vm._v("\n                  Cancel request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canApprove
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v("\n                  Approve all\n                ")])])])])]) : _c('div', [(_vm.preview.eligibleCount === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              No notes on this account can be transferred\n              "), (_vm.preview.ineligibleCount) ? _c('span', [_vm._v("\n                — all " + _vm._s(_vm.preview.ineligibleCount) + " of them are excluded.\n                See the reasons below.\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferSearch"
    }
  }, [_vm._v("Destination account *")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.text),
      expression: "search.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferSearch",
      "type": "text",
      "placeholder": "Search account number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.search.text || _vm.searching
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n                ")])])])]), _vm._v(" "), (_vm.search.hasSearched && !_vm.search.account && !_vm.searching) ? _c('div', {
    staticClass: "alert alert-info not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No results found.")])]) : _vm._e(), _vm._v(" "), (_vm.selectedAccount || _vm.search.account) ? _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.selectedAccount) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountName))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.search.account && !_vm.isSelected(_vm.search.account)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.search.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.search.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAccount(_vm.search.account)
      }
    }
  }, [_vm._v("\n                    Select account\n                  ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.preview.warnings.length) ? _c('div', {
    staticClass: "alert alert-warning warnings-block",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_vm._v("Before this account is migrated")]), _vm._v(" "), _c('ul', {
    staticClass: "warning-list"
  }, _vm._l((_vm.preview.warnings), function(warning) {
    return _c('li', {
      key: warning.code
    }, [_vm._v("\n                " + _vm._s(warning.text) + "\n              ")])
  }))]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox closed-notes-toggle"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeClosedNotes),
      expression: "includeClosedNotes"
    }],
    attrs: {
      "type": "checkbox",
      "name": "includeClosedNotes"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeClosedNotes) ? _vm._i(_vm.includeClosedNotes, null) > -1 : (_vm.includeClosedNotes)
    },
    on: {
      "change": function($event) {
        _vm.loadPreview()
      },
      "__c": function($event) {
        var $$a = _vm.includeClosedNotes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeClosedNotes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.includeClosedNotes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeClosedNotes = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Include closed notes\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted closed-notes-hint"
  }, [_vm._v("\n              Closed notes carry no balance. Moving them keeps the account's\n              history together rather than splitting it across two accounts.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.preview.eligibleCount))]), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  (" + _vm._s(_vm.preview.ineligibleCount) + " excluded)\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal moving")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.preview.totals.principal)) + "\n              ")])]), _vm._v(" "), (_vm.preview.electionsToReset) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("\n                  Upcoming transactions\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.preview.electionsToReset) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.preview.terminalNoteCount) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Closed or cancelled notes staying here")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.preview.terminalNoteCount))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferComment"
    }
  }, [_vm._v("Please append your comment *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.comment),
      expression: "comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferComment",
      "rows": "2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.preview.eligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.eligibleCount) + " notes\n              being transferred\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Maturity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Upcoming")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.eligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(note.electionsToReset) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('em', {
      staticClass: "fa fa-warning pr-sm"
    }), _vm._v(_vm._s(note.electionsToReset) + "\n                    ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showExcluded = !_vm.showExcluded
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showExcluded ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.ineligibleCount) + " notes\n              that would stay\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showExcluded) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', [_vm._v("Why it stays")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.ineligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(note.ineligibilityText))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("\n                  Transfer " + _vm._s(_vm.preview.eligibleCount) + " notes\n                ")])])])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23453074","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BulkTransfer.vue
// module id = 2117
// module chunks = 1